import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import classnames from "classnames";
import AdminEventRaceDayTickets from "./AdminEventRaceDayTickets";
import AdminEventTrackside from "./AdminEventTrackside";
import AdminEventHospitality from "./AdminEventHospitality";
import {loadEventsAction} from "~/Admin/redux/actions/event";
import TopSubmenu from "~/Admin/Layout/TopSubmenu/TopSubmenu";

const AdminEventExperiences = ({match, event, ...props}) => {

    const [active, setActive] = useState('Race Day Tickets');

    const tabs = [
        'Race Day Tickets',
        'Trackside Experiences',
        'Trackside Hospitality',
    ];

    const updated = () => {

        props.dispatch(loadEventsAction());
    };

    return (
        <div className="admin-event-experiences">
            <div className="row">

                <div className="col-12">
                    <TopSubmenu classes="card shadow-sm bg-white">
                        {tabs.map(tab => (
                            <a href="#"
                               key={tab}
                               onClick={(e) => setActive(tab)}
                               className={classnames({active: tab === active})}>
                                {tab}
                            </a>
                        ))}
                    </TopSubmenu>
                </div>

                {active && (
                    <div className="col-12 mt-1">
                        {active === 'Race Day Tickets' && <AdminEventRaceDayTickets onChange={updated}/>}
                        {active === 'Trackside Experiences' && <AdminEventTrackside onChange={updated}/>}
                        {active === 'Trackside Hospitality' && <AdminEventHospitality onChange={updated}/>}
                    </div>
                )}
            </div>
        </div>

    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEventExperiences);
